/* Cart-first submission for Divine product pages. */
(() => {
  if (window.divineCartFirstInstalled) return;
  window.divineCartFirstInstalled = true;

  let pendingForm = null;

  function reset(form) {
    if (!form) return;
    form.inert = false;
    form.removeAttribute('aria-busy');
    const button = form.querySelector('[name="add"]');
    const variant = form.querySelector('[data-product-variant-id]');
    if (button) {
      button.disabled = Boolean(variant?.selectedOptions[0]?.disabled);
      const label = button.querySelector('span');
      if (label) label.textContent = button.dataset.addLabel || 'Add to cart';
    }
    if (pendingForm === form) pendingForm = null;
  }

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) ||
        !form.matches('.divine-product-form[data-divine-cart-first="true"]') ||
        event.defaultPrevented) return;

    if (pendingForm) {
      event.preventDefault();
      return;
    }

    const button = form.querySelector('[name="add"]');
    const variant = form.querySelector('[data-product-variant-id]');
    if (!button || button.disabled || !variant?.value ||
        variant.selectedOptions[0]?.disabled || !form.reportValidity()) {
      event.preventDefault();
      return;
    }

    const cart = document.querySelector('cart-drawer');
    /* Native Shopify submission opens the cart page if the drawer is not ready. */
    if (!cart || typeof cart.getSectionsToRender !== 'function' ||
        typeof cart.renderContents !== 'function') return;

    event.preventDefault();
    const data = new FormData(form);
    data.delete('divine-variant');
    const id = data.get('id');
    const quantity = Number(data.get('quantity') || 1);
    const endpoint = new URL(form.action, location.origin);
    endpoint.pathname = endpoint.pathname.replace(/\/add\/?$/, '/add.js');
    endpoint.search = '';
    endpoint.hash = '';
    const cartUrl = new URL(form.dataset.divineCartUrl ||
      form.action.replace(/\/add\/?$/, ''), location.origin);

    let sections;
    try {
      sections = cart.getSectionsToRender();
      data.set('sections', sections.map(section => section.id).join(','));
      data.set('sections_url', location.pathname);
    } catch {
      /* No request was sent; allow normal form submission. */
      form.submit();
      return;
    }

    cart.setActiveElement?.(button);
    const error = form.querySelector('[data-product-error]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    pendingForm = form;
    button.disabled = true;
    form.inert = true;
    form.setAttribute('aria-busy', 'true');
    const label = button.querySelector('span');
    if (label) label.textContent = 'Adding…';
    let navigating = false;

    try {
      const response = await fetch(endpoint.href, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      const result = await response.json();
      if (!response.ok || Number(result.status) >= 400) {
        throw new Error(typeof result.description === 'string' ? result.description :
          'Unable to add this item. Please check your cart before trying again.');
      }

      const added = result.items?.find(item =>
        String(item.variant_id ?? item.id) === String(id)) || result;
      if (String(added.variant_id ?? added.id) !== String(id) ||
          !Number.isFinite(Number(added.quantity)) ||
          Number(added.quantity) < quantity) {
        throw new Error('Your selection could not be confirmed. Please check your cart before trying again.');
      }

      /* An add can succeed even if Shopify cannot render the requested sections. */
      if (!sections.every(section => typeof result.sections?.[section.id] === 'string' &&
          result.sections[section.id].trim())) {
        navigating = true;
        location.assign(cartUrl.href);
        return;
      }

      try {
        cart.classList.remove('is-empty');
        cart.renderContents(result);
      } catch {
        /* The item is already added: open the cart without adding it a second time. */
        navigating = true;
        location.assign(cartUrl.href);
      }
    } catch (reason) {
      if (error) {
        error.textContent = reason instanceof TypeError || reason instanceof SyntaxError ?
          'Unable to confirm the cart update. Please check your cart before trying again.' :
          reason.message;
        error.hidden = false;
      }
    } finally {
      if (!navigating) reset(form);
    }
  }, true);

  window.addEventListener('pageshow', event => {
    if (event.persisted) reset(pendingForm);
  });
})();
